import { createContext } from 'react'

import { SelectionManager } from './useSelectionManager'

interface SummaryContextValue {
  selectable: boolean
  selectionManager?: SelectionManager
}

// Create a context with a default value
export const SummaryContext = createContext<SummaryContextValue>({
  selectable: false,
  selectionManager: undefined,
})
